import { Show, type Component } from 'solid-js';
import { WifiOff } from 'lucide-solid';
import { useNetworkStatus } from '~/shared/lib/network';
import { useI18n } from '~/shared/lib/i18n';

export const OfflineBanner: Component = () => {
  const { t } = useI18n();
  const { online } = useNetworkStatus();
  return (
    <Show when={!online()}>
      <div
        role="status"
        aria-live="polite"
        class="fixed top-0 left-0 right-0 z-[900] flex items-center justify-center gap-2 h-8 text-[13px] font-medium text-white"
        style={{ background: 'linear-gradient(90deg, var(--color-danger), var(--color-warning))' }}
      >
        <WifiOff class="h-4 w-4" />
        <span>{t('common.offline')}</span>
      </div>
    </Show>
  );
};
